var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "66px",
    height: "66px",
    viewBox: "0 0 66 66",
    enableBackground: "new 0 0 66 66",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#063F66",
    cx: 33,
    cy: 33.002,
    r: 31.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#022730",
    d: "M10.903,10.904c12.203-12.205,31.99-12.205,44.193,0c12.204,12.203,12.204,31.99,0,44.193"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DCF9F6",
    cx: 18.537,
    cy: 54.949,
    rx: 0.289,
    ry: 2.693
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DCF9F6",
    cx: 18.537,
    cy: 54.95,
    rx: 2.691,
    ry: 0.288
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7088 0.7054 -0.7054 0.7088 30.5858 -32.8458)",
    fill: "#DCF9F6",
    cx: 55.076,
    cy: 20.623,
    rx: 0.288,
    ry: 2.692
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7088 0.7054 -0.7054 -0.7088 108.6619 -3.6106)",
    fill: "#DCF9F6",
    cx: 55.076,
    cy: 20.623,
    rx: 0.288,
    ry: 2.692
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DCF9F6",
    cx: 47.589,
    cy: 12.336,
    rx: 0.124,
    ry: 1.154
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#DCF9F6",
    cx: 47.59,
    cy: 12.336,
    rx: 1.154,
    ry: 0.124
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7035 -0.7107 0.7107 0.7035 -3.2327 21.4707)",
    fill: "#DCF9F6",
    cx: 24.114,
    cy: 14.609,
    rx: 0.135,
    ry: 1.253
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7035 0.7107 -0.7107 0.7035 17.5338 -12.8065)",
    fill: "#DCF9F6",
    cx: 24.114,
    cy: 14.609,
    rx: 0.135,
    ry: 1.251
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7053 -0.7089 0.7089 0.7053 -29.5355 23.8529)",
    fill: "#DCF9F6",
    cx: 13.921,
    cy: 47.45,
    rx: 0.134,
    ry: 1.253
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7053 0.7089 -0.7089 0.7053 37.7408 4.1152)",
    fill: "#DCF9F6",
    cx: 13.921,
    cy: 47.45,
    rx: 0.134,
    ry: 1.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7143 0.6999 -0.6999 0.7143 19.1365 -24.6079)",
    fill: "#DCF9F6",
    cx: 39.707,
    cy: 11.133,
    rx: 0.068,
    ry: 0.626
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7143 0.6999 -0.6999 -0.7143 75.86 -8.7032)",
    fill: "#DCF9F6",
    cx: 39.707,
    cy: 11.133,
    rx: 0.068,
    ry: 0.626
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7107 0.7035 -0.7035 0.7107 48.8603 -3.5359)",
    fill: "#DCF9F6",
    cx: 28.729,
    cy: 57.642,
    rx: 0.067,
    ry: 0.627
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7107 0.7035 -0.7035 -0.7107 89.6978 78.3993)",
    fill: "#DCF9F6",
    cx: 28.729,
    cy: 57.642,
    rx: 0.067,
    ry: 0.625
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#DCF9F6",
    cx: 33,
    cy: 33,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#95BFB9",
    d: "M33,53c-11.046,0-20-8.954-20-20c0-11.047,8.954-20,20-20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CAEDE7",
    d: "M33,53c-11.046,0-10.826-8.954-10.826-20c0-11.047-0.22-20,10.826-20"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 19.132,
    cy: 22.355,
    r: 1.167
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 17.382,
    cy: 26.939,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 25.465,
    cy: 29.523,
    r: 3.667
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 27.132,
    cy: 21.357,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3E5E0",
    cx: 33.965,
    cy: 20.855,
    r: 0.333
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 36.632,
    cy: 17.523,
    r: 0.333
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 26.966,
    cy: 17.689,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 30.965,
    cy: 16.023,
    r: 0.167
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3E5E0",
    cx: 35.632,
    cy: 27.523,
    r: 0.833
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3E5E0",
    cx: 41.632,
    cy: 27.023,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3E5E0",
    cx: 42.882,
    cy: 21.273,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3E5E0",
    cx: 39.382,
    cy: 37.439,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 21.299,
    cy: 38.689,
    r: 0.667
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 28.465,
    cy: 35.689,
    r: 0.333
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 31.965,
    cy: 43.189,
    r: 1.167
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 17.382,
    cy: 33.607,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3E5E0",
    cx: 35.216,
    cy: 33.107,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95BFB9",
    cx: 44.799,
    cy: 33.523,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 23.632,
    cy: 44.189,
    r: 1.167
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 26.049,
    cy: 39.939,
    r: 0.417
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3E5E0",
    cx: 38.382,
    cy: 44.605,
    r: 0.417
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 31.965,
    cy: 47.855,
    r: 0.333
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 27.049,
    cy: 47.439,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95BFB9",
    cx: 43.382,
    cy: 42.773,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3E5E0",
    cx: 37.299,
    cy: 48.689,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 32.549,
    cy: 37.939,
    r: 0.417
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#95BFB9",
    cx: 46.049,
    cy: 39.273,
    r: 0.75
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#78A8A0",
    cx: 18.632,
    cy: 42.189,
    r: 0.667
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#C3E5E0",
    cx: 40.549,
    cy: 31.939,
    r: 0.917
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.00b09c41785bdb7e177b5e184007933a.svg";
export { ForwardRef as ReactComponent };